<div>
    <div>
        <div style="display: block">
            <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [colors]="doughnutChartColors" [chartType]="doughnutChartType">
        </canvas>
        </div>
    </div>
</div>